module.exports = __webpack_public_path__ + "static/media/S4N5-5.50de4833.svg";